// Mock data for OJ Holdings LLC website

export const companyInfo = {
  name: "OJ Holdings LLC",
  tagline: "Building Legacy Through Strategic Investments",
  description: "OJ Holdings LLC is a premier holding company dedicated to acquiring, nurturing, and growing exceptional businesses across diverse industries.",
  founded: "2020",
  headquarters: "United States",
  email: "ojholdingsllc@outlook.com"
};

export const aboutContent = {
  mission: "To build lasting value through strategic acquisitions and hands-on operational excellence, empowering businesses to reach their full potential.",
  vision: "To become a leading holding company recognized for transforming promising ventures into industry leaders while maintaining the highest standards of integrity and innovation.",
  values: [
    {
      title: "Excellence",
      description: "We pursue the highest standards in everything we do, from investment decisions to operational management."
    },
    {
      title: "Integrity",
      description: "We conduct business with unwavering honesty, transparency, and ethical principles."
    },
    {
      title: "Growth",
      description: "We are committed to sustainable growth that benefits our portfolio companies, partners, and stakeholders."
    },
    {
      title: "Partnership",
      description: "We build lasting relationships based on trust, mutual respect, and shared success."
    }
  ],
  leadership: [
    {
      name: "Leadership Team",
      role: "Executive Management",
      description: "Our experienced leadership team brings decades of combined expertise in business development, operations, and strategic growth."
    }
  ]
};

export const portfolioCompanies = [
  {
    id: 1,
    name: "Malandros LLC",
    type: "Consulting Company",
    description: "A dynamic consulting firm specializing in retail and wholesale business operations. Malandros LLC provides strategic guidance and operational support to help businesses optimize their supply chains, improve margins, and scale effectively.",
    services: [
      "Retail Strategy & Operations",
      "Wholesale Distribution",
      "Supply Chain Optimization",
      "Business Development"
    ],
    status: "Active",
    acquired: "2022"
  }
];

export const stats = [
  { label: "Portfolio Companies", value: "1+" },
  { label: "Industries Served", value: "2+" },
  { label: "Years of Excellence", value: "5+" },
  { label: "Growth Focus", value: "100%" }
];

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Portfolio", path: "/portfolio" }
];
